import React from 'react';

import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';

import ErrorModal from '../ErrorModal';
import MutationRequest from '../MutationRequest';

export const CREATE_CONTENT_GROUP_FORM = gql`
  mutation CreateContentGroupForm(
    $projectId: String!
    $title: String!
    $description: String!
    $formType: EFormType
  ) {
    contentGroup {
      createContentGroupForm(
        contentGroupform: {
          projectId: $projectId
          title: $title
          description: $description
          formType: $formType
        }
      ) {
        id
        title
        description
        url
        formType
        contentPages {
          id
          contentSections {
            id
            sectionContainers {
              id
            }
          }
        }
      }
    }
  }
`;

const createContentGroupForm = ({
  projectId,
  title,
  description,
  onError,
  onSuccessResult,
  formType,
}) => (
  <Mutation mutation={CREATE_CONTENT_GROUP_FORM}>
    {(createContentGroup, { loading, error, data }) => {
      const variables = {
        projectId,
        title,
        description,
        formType,
      };
      if (error) {
        return <ErrorModal error={error} onError={onError} />;
      }
      if (data) {
        onSuccessResult(data.contentGroup.createContentGroupForm);
      }

      return (
        <MutationRequest
          isLoading={loading}
          mutation={createContentGroup}
          variables={variables}
        />
      );
    }}
  </Mutation>
);

createContentGroupForm.propTypes = {
  description: PropTypes.string.isRequired,
  formType: PropTypes.string.isRequired,
  onError: PropTypes.func.isRequired,
  onSuccessResult: PropTypes.func.isRequired,
  projectId: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default createContentGroupForm;
